export default "__VITE_ASSET__CTpopfOe__"